
import { call, put } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    setOperationError,
} from '../common';

import { getPermissions } from './serverApi/security';

export const GET_PERMISSIONS_ACTION_TYPE = createActionTypes('permissions/GET');

export function* workGetPermissions(options, actionType, action) {
    try {
        yield call(clearActionType);
        yield put({type: actionType.LOADING});
        const data = yield call(
            getPermissions,
            {
                operation: GET_PERMISSIONS_ACTION_TYPE.DEFAULT,
                token: action.token,
                projectId: action.projectId,
            }
        );
        yield put({type: actionType.SUCCESS, data});
    } catch (error) {
        yield call(setOperationError, error, actionType);
    }
}
